import { render, staticRenderFns } from "./CreateEvent.vue?vue&type=template&id=b5a83dec&scoped=true&"
import script from "./CreateEvent.vue?vue&type=script&lang=ts&"
export * from "./CreateEvent.vue?vue&type=script&lang=ts&"
import style0 from "./CreateEvent.vue?vue&type=style&index=0&id=b5a83dec&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5a83dec",
  null
  
)

export default component.exports